export default __webpack_public_path__ + "static/media/gallery-wip-pommel_08.198496e0.jpg";